import { useState, useEffect } from "react"
import { motion } from "framer-motion"
import whiteSVG from "../assets/images/WhiteBackground.png"

const Terms = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 640)
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)
    return () => window.removeEventListener("resize", checkMobile)
  }, [])

  const sections = [
    {
      title: "1. Use of Services",
      content: `Our services, including the <span class="text-black font-semibold">MarketMind</span> ERP system, are designed to provide businesses, commission agents, and other users with tools for managing their operations efficiently. You are granted a limited, non-transferable, and revocable license to use our services for your personal or business purposes, provided that you comply with these terms. Unauthorized use, including but not limited to reselling, redistributing, or reverse-engineering our services, is strictly prohibited. You are responsible for ensuring that your use of the services complies with all applicable laws, regulations, and guidelines.

You must be at least 18 years old to use our services. By using the platform, you confirm that you meet this age requirement and have the authority to enter into these terms. If you are registering on behalf of a business or organization, you represent that you have the authority to bind the entity to these terms.`,
    },
    {
      title: "2. Account Registration and Security",
      content: `To access certain features of our services, you may be required to create an account. When registering, you agree to provide accurate, complete, and up-to-date information. You are responsible for maintaining the confidentiality of your account credentials, including your username and password. Any activity conducted under your account will be deemed your responsibility. If you suspect unauthorized access to your account, you must notify us immediately at <span class="text-black font-semibold">support@lightningtechnologies.net</span>.

You agree not to use another user's account without permission. We reserve the right to suspend or terminate accounts that are found to be in violation of these terms or any applicable laws. Additionally, multiple failed login attempts or suspicious activities may lead to account suspension to protect the integrity and security of our platform.`,
    },
    {
      title: "3. Payment and Subscription",
      content: `Certain features of the <span class="text-black font-semibold">MarketMind</span> platform may require payment, such as subscription plans or one-time license fees. By purchasing a subscription or product, you agree to pay all applicable fees, including taxes, according to the payment terms displayed at the time of purchase. Payments are processed through third-party payment providers, and you agree to their terms and conditions as part of the transaction.

You are responsible for providing accurate billing information and ensuring that your payment method remains valid. Failure to make timely payments may result in the suspension or termination of your access to paid features. Subscription services may be subject to automatic renewal unless you cancel the subscription before the renewal date. Refund policies will be governed by applicable laws and our internal policies.`,
    },
    {
      title: "4. User Conduct",
      content: `You agree to use our services only for lawful purposes and in a manner that does not infringe on the rights of others. Prohibited activities include, but are not limited to, posting or transmitting unlawful, harmful, defamatory, or obscene content; attempting to hack or compromise the security of our systems; and engaging in activities that disrupt the normal functioning of our services.

You are responsible for all content you submit or upload to the platform, including ensuring that you have the necessary rights and permissions to do so. We reserve the right to remove content that violates these terms or is deemed inappropriate by our team, without prior notice.`,
    },
    {
      title: "5. Intellectual Property Rights",
      content: `All content, features, and functionality provided on our website and within the <span class="text-black font-semibold">MarketMind</span> platform, including but not limited to software, graphics, logos, designs, and text, are the exclusive property of <span class="text-black font-semibold">Lightning Technologies</span> or its licensors. These materials are protected by intellectual property laws, including copyright, trademark, and patent laws.

You may not reproduce, distribute, modify, or create derivative works based on our content without prior written permission. The <span class="text-black font-semibold">MarketMind</span> logo and related branding are trademarks of <span class="text-black font-semibold">Lightning Technologies</span> and may not be used without authorization. Unauthorized use of our intellectual property may result in legal action.`,
    },
    {
      title: "6. Data Privacy",
      content: `Your privacy is important to us. By using our services, you consent to the collection, use, and processing of your personal data as outlined in our <span class="text-black font-semibold">Privacy Policy</span>. We implement industry-standard security measures to protect your data; however, no system is entirely foolproof. You are responsible for safeguarding your account credentials and taking precautions to protect your data when using our platform.

For more information on how we handle your data, please refer to our <span class="text-black font-semibold">Privacy Policy</span>.`,
    },
    {
      title: "7. Limitation of Liability",
      content: `To the fullest extent permitted by law, <span class="text-black font-semibold">Lightning Technologies</span> and its affiliates, officers, employees, and partners shall not be liable for any direct, indirect, incidental, or consequential damages arising from your use of our services. This includes, but is not limited to, loss of data, revenue, or business opportunities, even if we have been advised of the possibility of such damages.

Our services are provided on an "as-is" and "as-available" basis, without any warranties of any kind, express or implied. We do not guarantee that our services will be uninterrupted, error-free, or secure. You use our services at your own risk.`,
    },
    {
      title: "8. Indemnification",
      content: `You agree to indemnify and hold harmless <span class="text-black font-semibold">Lightning Technologies</span>, its affiliates, and employees from any claims, damages, or expenses arising from your use of the services, violation of these terms, or infringement of any third-party rights. This includes covering legal fees and costs associated with any such claims.`,
    },
    {
      title: "9. Modifications to Services",
      content: `We reserve the right to modify, suspend, or discontinue any aspect of our services at any time without prior notice. This includes changes to features, pricing, or availability. We are not liable for any disruption or inconvenience caused by such modifications.

We may also update these Terms and Conditions periodically to reflect changes in our services or legal requirements. You will be notified of significant updates through email or in-app notifications. Continued use of the services after updates signifies your acceptance of the revised terms.`,
    },
    {
      title: "10. Governing Law and Dispute Resolution",
      content: `These terms shall be governed by and construed in accordance with the laws of <span class="text-black font-semibold">India</span>. Any disputes arising from or relating to these terms shall be resolved through arbitration in <span class="text-black font-semibold">Pune, Maharashtra</span>, in accordance with the Indian Arbitration and Conciliation Act, 1996. The arbitration proceedings will be conducted in English, and the decision of the arbitrator(s) will be final and binding.`,
    },
    {
      title: "11. Contact Information",
      content: `For questions, concerns, or requests related to these Terms and Conditions, please contact us at:
      <br/>
<span class="text-black font-semibold">Lightning Technologies</span>
 <br/>
 Email: <span class="text-black font-semibold">support@lightningtechnologies.net</span>
 <br/>
 Address: <span class="text-black font-semibold">Pune, Maharashtra, India</span>
  <br/>

Thank you for choosing <span class="text-black font-semibold">Lightning Technologies</span>. By adhering to these terms, we aim to provide you with a secure and efficient experience on our platform.`,
    },
  ]

  return (
    <div className="bg-white">
      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{
          backgroundImage: `url(${whiteSVG})`,
          backgroundSize: isMobile ? "cover" : "100% 100%",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          padding: "10px",
          marginTop: "-100px",
          paddingTop: "200px",
          paddingLeft: isMobile ? "20px" : "220px",
          paddingRight: isMobile ? "20px" : "300px",
          paddingBottom: "200px",
        }}
        className="font-bold text-4xl sm:text-5xl text-center sm:text-left mb-12"
      >
        Terms & Conditions
      </motion.div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="bg-white shadow-lg rounded-2xl p-6 sm:p-8"
        >
          <p className="text-gray-700 leading-relaxed text-base sm:text-lg text-justify">
            Welcome to the official website of <strong className="text-black">Lightning Technologies</strong>. By
            accessing or using our website and services, including the{" "}
            <strong className="text-black">MarketMind</strong> ERP platform, you agree to comply with these Terms and
            Conditions.
          </p>

          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mt-8 sm:mt-12 mb-4 sm:mb-6 text-center">
            Key Aspects Covered
          </h2>

          <div className="space-y-6 sm:space-y-8">
            {sections.map((section, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="bg-white p-4 sm:p-6 rounded-xl shadow-md transition-all duration-300 hover:shadow-xl border-l-4 border-[#BDE9FB] hover:scale-105"
              >
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">{section.title}</h3>
                <div
                  className="text-gray-700 text-sm sm:text-base leading-relaxed break-words"
                  dangerouslySetInnerHTML={{ __html: section.content }}
                />
              </motion.div>
            ))}
          </div>

          {/* Legal Disclaimer */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 1, delay: 0.2 }}
            className="mt-8 sm:mt-12 p-4 sm:p-6 bg-[#BDE9FB] rounded-lg border border-gray-300 text-center"
          >
            <p className="text-xs sm:text-sm text-gray-700 italic">
              *The information provided here is for general understanding only and should not be considered legal
              advice. For personalized legal guidance, consult with a qualified legal professional.*
            </p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  )
}

export default Terms

